import React, { useRef, useState } from 'react';
import { useDispatch } from "react-redux";
import { PlaybackPauseIcon, PlaybackPlayIcon, ClearIcon } from '../Iconset';
import { StoreActions } from '../../state/store';
import ProgressBar from '../layout/ProgressBar';
import { useTypedDispatch } from '../../state/hooks';

interface IUIVideoPlayerProps
{
	videoUrl: string | null;
	audioOnly?: boolean;
}

const UIVideoPlayer: React.FC<IUIVideoPlayerProps> = React.memo((props) =>
{
	const dispatch = useTypedDispatch();
	
	const [videoDuration, setVideoDuration] = useState(0);
	const [videoTime, setVideoTime] = useState(0);
	const [isPlaying, setIsPlaying] = useState(false);
	
	const videoElement = useRef<HTMLVideoElement>(null);

	function onPlayPauseClick(e)
	{
		if (videoElement.current)
		{
			if (isPlaying)
			{
				videoElement.current.pause();
			}
			else
			{
				videoElement.current.play();
			}
		}
	}

	function closeVideoPlayer()
	{
		dispatch(StoreActions.ui.showVideoPlayer({
			visible: false
		}));
	}

	if (props.videoUrl)
	{
		return props.audioOnly === true ? (
			<div className='audio-player-background'
				data-name={"audio-player-root-" + props.videoUrl}
				onClick={() =>
				{
					closeVideoPlayer();
				}}
			>
				<audio key='audio-player'
					data-name={"audio-player"}
					ref={videoElement}
					style={{
						objectFit: "contain",
						width: '40%',
						// height: '100%',
					}}
					src={props.videoUrl}
					autoPlay
					// controls
					onPlay={() =>
					{
						if(!videoElement.current) return;

						setVideoDuration(Math.trunc(videoElement.current.duration));
						setIsPlaying(true);
					}}
					onPause={() =>
					{
						setIsPlaying(false);
					}}
					onEnded={() =>
					{
						closeVideoPlayer();
					}}
					onTimeUpdate={() =>
					{
						if(!videoElement.current) return;

						setVideoTime(Math.trunc(videoElement.current.currentTime));
					}} />
			</div>
		) : (
			<div className='video-player-background'
				data-name={"video-player-root-" + props.videoUrl}
			>
				<video key='video-player'
					data-name={"video-player"}
					ref={videoElement}
					style={{
						objectFit: "contain",
						width: '100%',
						height: '100%',
					}}
					src={props.videoUrl}
					autoPlay
					onPlay={() =>
					{
						if(!videoElement.current) return;

						setVideoDuration(Math.trunc(videoElement.current.duration));
						setIsPlaying(true);
					}}
					onPause={() =>
					{
						setIsPlaying(false);
					}}
					onEnded={() =>
					{
						closeVideoPlayer();
					}}
					onTimeUpdate={() =>
					{
						if(!videoElement.current) return;

						setVideoTime(Math.trunc(videoElement.current.currentTime));
					}} />
				<div className='video-player-controls'
					data-name={"video-player-controls"}
				>
					<ProgressBar className={"videoPlaybackProgress"}
						progress={videoTime / videoDuration}
					/>
					<div className='video-player-duration'
						data-name={"vide-player-duration-counter"}
					>
						{videoTime} / {videoDuration} s
					</div>
					{
						isPlaying ?
							<PlaybackPauseIcon scale={2}
								className='video-player-play-pause'
								data-name={"video-player-play-button"}
								onClick={onPlayPauseClick}
							/>
							:
							<PlaybackPlayIcon scale={2}
								className='video-player-play-pause'
								data-name={"video-player-pause-button"}
								onClick={onPlayPauseClick}
							/>
					}
					<ClearIcon scale={2}
						className='video-player-close'
						data-name={"video-player-close-button"}
						onClick={closeVideoPlayer}
					/>
				</div>
			</div>
		);
	}

	return null;
});

export default UIVideoPlayer;